import type { ComputerUseStatus } from '@crowdex/agent-contracts/api';
import type { AcpAgentCatalogData } from '@/app/api/acp/agents/route';
import type { NativeAgent } from '@/lib/native-desktop';

/**
 * What `/desktop-preview` shows of this computer in Settings (its agents, computer use), where
 * the preview has no machine behind it. `null` everywhere else: the real machine answers.
 */
export type SettingsPreview = {
  local: boolean;
  agents: { runtime: NativeAgent[]; catalog: AcpAgentCatalogData[] };
  computerUse: ComputerUseStatus;
};

let preview: SettingsPreview | null = null;

export function settingsPreview(): SettingsPreview | null {
  return preview;
}

export function setSettingsPreview(next: SettingsPreview | null): void {
  preview = next;
}
